<div class="campaign-breadcrumb-bar">
  <div class="breadcrumb-row">
    @if (accountName && !isMobile) {
      <div class="breadcrumb-section">
        <span class="breadcrumb-item-text">{{ accountName }}</span>
        <i class="material-icons arrow-icon">arrow_forward_ios</i>
      </div>
    }

    @if (!isMobile && isAppExperience) {
      <div class="breadcrumb-section">
        <a class="text-link" href [routerLink]="'/app-experiences'">
          <span class="breadcrumb-item-text clickable">{{ "top-level-side-menu.app-experiences" | translate | uppercase }}</span>
        </a>
        <i class="material-icons arrow-icon">arrow_forward_ios</i>
      </div>
    }

    @if (showOnsiteExperiencesLink) {
      <div class="breadcrumb-section">
        <a class="text-link" href [routerLink]="onsiteExperiencesLink">
          <span class="breadcrumb-item-text clickable">{{ "top-level-side-menu.onsite-experiences" | translate | uppercase }}</span>
        </a>
        <i class="material-icons arrow-icon">arrow_forward_ios</i>
      </div>
    }

    <div class="breadcrumb-section name-campaign-section">
      @if (!isChangingName) {
        <a [attr.href]="settingsHref" (click)="onCampaignNameClick($event)" class="breadcrumb-item-text clickable">
          {{
            currentItemText !== undefined
              ? currentItemText !== "" && currentItemText !== null
                ? currentItemText
                : ("breadcrumb.label-new-campaign" | translate)
              : ""
          }}
        </a>
      }
      @if (isChangingName) {
        <input
          maxlength="50"
          [style.width.px]="nameWidth"
          (input)="resizeInputName()"
          [(ngModel)]="campaignName"
          #nameEdit
          type="text"
          value="{{
            currentItemText !== undefined
              ? currentItemText !== '' && currentItemText !== null
                ? currentItemText
                : ('breadcrumb.label-new-campaign' | translate)
              : ''
          }}"
          class="changing-name-input" />
      }
      @if (isChangingName) {
        <button (click)="saveChangedName()" class="primary-button save-button">Save</button>
      }
      @if (hasUnpublishedChanges && campaign?.type !== CampaignTypes.ABTesting && campaign?.status === OnsiteCampaignStatuses.Published) {
        <span matTooltip="{{ 'widgets.campaigns.campaignHasChanges' | translate }}" class="breadcrumb-item-text mark-unpublished">(*)</span>
      }
      @if (!isChangingName && this.variantId) {
        <i class="material-icons edit" (click)="changeName()" matTooltip="click to change name">edit</i>
      }
    </div>

    @if (widgetState?.name) {
      <div class="breadcrumb-section name-campaign-section">
        <i class="material-icons arrow-icon">arrow_forward_ios</i>
        @if (!isChangingVariant) {
          <span class="breadcrumb-item-text">
            {{ variantName != undefined ? (variantName !== "" && variantName !== null ? variantName : widgetState?.name) : widgetState?.name }}
          </span>
        }
        @if (isChangingVariant) {
          <input
            maxlength="50"
            [(ngModel)]="variantName"
            #variantEdit
            (input)="resizeInputVariant()"
            [style.width.px]="variantWidth"
            type="text"
            value="{{ variantName }}"
            class="changing-name-input" />
        }
        @if (isChangingVariant) {
          <button (click)="saveChangedVariant()" class="primary-button save-button">Save</button>
        }
        @if (hasUnpublishedChanges && campaign?.type !== CampaignTypes.ABTesting && campaign?.status === OnsiteCampaignStatuses.Published) {
          <span matTooltip="{{ 'widgets.campaigns.campaignHasChanges' | translate }}" class="breadcrumb-item-text mark-unpublished">(*)</span>
        }
        @if (!isChangingVariant) {
          <i class="material-icons edit variant" (click)="changeVariant()" matTooltip="click to change name">edit</i>
        }
      </div>
    }
  </div>
</div>
<span #invisibleName id="invisible-text">
  <br />
  {{ campaignName }}
</span>
<span #invisibleVariant id="invisible-text">
  <br />
  {{ variantName }}
</span>
